import { FC } from "react";
import Tabs from "@components/new/Tabs/Tabs";
import { ID } from "@models";
import { PlacesFoodsTab } from "./PlacesFoodsTabs.helpers";

export type { PlacesFoodsTab };

const PLACES_ID = 1;
const FOODS_ID = 2;

interface iProps {
    activeTab: PlacesFoodsTab;
    /** Switches the tab in place — US Chains renders both tabs on one page. */
    onChange: (tab: PlacesFoodsTab) => void;
    testId?: string;
}

const PlacesFoodsTabs: FC<iProps> = ({ activeTab, onChange, testId }) => {
    const handleChange = (id: ID) => {
        const nextTab: PlacesFoodsTab = id === FOODS_ID ? "foods" : "places";
        if (nextTab !== activeTab) onChange(nextTab);
    };

    return (
        <Tabs
            testId={testId}
            selectedId={activeTab === "places" ? PLACES_ID : FOODS_ID}
            onChange={handleChange}
            items={[
                { id: PLACES_ID, title: "Places", testId: "buttonTabPlaces" },
                { id: FOODS_ID, title: "Foods", testId: "buttonTabFoods" },
            ]}
        />
    );
};

export default PlacesFoodsTabs;
